import { ReloadIcon } from "@radix-ui/react-icons";
import { Button, Flex, Text } from "@radix-ui/themes";
import { useTranslation } from "react-i18next";
import { BrandLogo } from "../../components/brand-logo";
import { LangSelector } from "./lang-selector";

export function OutOfService() {
  const { t } = useTranslation();

  return (
    <div className="p-6 mobile-fa bg-white h-dvh overflow-hidden select-none">
      <Flex direction="column" className="h-full">
        <Flex justify="between" mb="4">
          <BrandLogo />
          <LangSelector />
        </Flex>
        <Flex
          direction="column"
          flexGrow="1"
          gap="3"
          align="center"
          justify="center"
          className="pb-20"
        >
          <img src="/warning.webp" className="size-[190px]" alt="" />
          <Text className="font-semibold !text-[42px] leading-">
            {t("somethingWentWrong")}
          </Text>
          <Text size="5">{t("tryRefresh")}</Text>
          <Flex mt="3">
            <Button
              size="4"
              highContrast
              color="gray"
              radius="large"
              className="!min-h-14 !px-16 !rounded-2xl"
              onClick={() => location.reload()}
            >
              <ReloadIcon />
              {t("refreshPage")}
            </Button>
          </Flex>
        </Flex>
      </Flex>
    </div>
  );
}
